'use client'
import { Typography } from "antd";
import React from "react";

import WorldMap from "./worldMap";
const { Title } = Typography;

const GlobalServices = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center w-full">
        <Title level={2} className="H2 text-center">
          خدمات جهانی ما
        </Title>
        <p className="text-regal-black-lighter text-center w-full sm:w-2/3">
          تابرق خدماتی به وسعت جهان، در یک پکیج کامل با رویکرد و شبکه جهانی
          قدرتمند
        </p>
      </div>
      <div className="w-full">
        <WorldMap />
      </div>
    </div>
  );
};

export default GlobalServices;
